import lodash from 'lodash-es';
import intl from 'react-intl-universal';

import request from "./request";
import { convertBase64ToFile } from "./FileHelper";

const request_lib = request;
const _ = lodash;

// eslint-disable-next-line no-unused-vars
class req {
    static async get(url, options) {
        return await request_lib.get(url, options);
    }
    static async post(url, options) {
        return await request_lib.post(url, options);
    }
}

async function uploadFile(base64String, filename) {
    const blob = convertBase64ToFile(base64String, filename);

    const formData = new FormData();
    formData.append('file', blob, filename);

    const response = await req.post(`${window.base_url}/api_v3/files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
}

class Evisit {

    static parseUserStatus(user) {
        const status = Number(user.status);
        if (status === window.CONST.USER.STATUS.PENDING) {
            return intl.get("pending").d("Pending");
        } else if (status === window.CONST.USER.STATUS.CONFIRMED) {
            return intl.get("active").d("Active");
        } else if (status === window.CONST.USER.STATUS.DELETED) {
            return intl.get("pending_del").d("Pending delete");
        } else if (status === window.CONST.USER.STATUS.SUSPENDED) {
            return intl.get("suspended").d("Suspended");
        } else {
            return user.active ? intl.get("active").d("Active") : intl.get("inactive").d("Inactive");
        }
    }

    static noOptionsMessage = ({inputValue}) => {
        if (inputValue.length < 3) {
            const num = 3 - inputValue.length;
            return intl.get("select_min_input", {num}).d(`Please enter ${num} or more characters`);
        }
        return "No matches found";
    }

    static t = (v, args) => {
        let definition = _.get(window, "CONFIG.Account.customization.language.definition." + v);
        const lang_user = _.get(window, 'CONFIG.Account.customization.language.user');
        if (lang_user && Array.isArray(lang_user.type) && !lang_user.type.includes(window.user.type)) {
            definition = null;
        }
        const isPlural = args && args.indexOf(window.CONST.PLURAL) > -1;
        let result = null;

        if (definition && Array.isArray(definition) && definition.length > 0) {
            if (isPlural) {
                result = (definition.length > 1) ? definition[1] : intl.get(v, {num: 100});
            } else {
                result = definition[0];
            }
        }

        if (!result) {
            result = intl.get(v, {num: isPlural ? 100 : 1});
        }

        //Make a string's first character uppercase
        if (args && args.indexOf(window.CONST.CAPITAL) > -1) {
            result = _.upperFirst(result);
        }
        //Uppercase the first character of each word in a string
        if (args && args.indexOf(window.CONST.CAPITAL.WORDS) > -1) {
            result = _.startCase(_.toLower(result));
        }
        //Make a string uppercase
        if (args && args.indexOf(window.CONST.CAPITAL.ALL) > -1) {
            result = _.upperCase(result);
        }
        // Make a lowercase string
        if (args && args.indexOf('NORMAL') > -1) {
            result = _.lowerCase(result);
        }
        return result;
    }

    static getDefaultLogoUrl = (logoName) => {
        if (!logoName) {
            logoName = 'logo.png';
        }
        logoName += '?_v=' + window.CONFIG.App.Build;
        return window.base_url +  "/theme/MedicalOffice/img/" + logoName;
    }

    static getFaviconUrl = () => {
        const faviconId = Evisit.c('Account.favicon_id');
        if (faviconId) {
            return window.base_url + "/files/view/" + faviconId;
        }

        return "//cdn-no-cached-02.vsee.io/vc/phong/theme/MedicalOffice/favicon.ico?_v=" + window.CONFIG.App.Build
    }

    /**
     * shorthand for reading portal specific config e.g Evisit.c('Member.Type');
     *
     * @param {*} val
     * @param {*} defaultValue
     * @returns
     */
    static c = (val = null, defaultValue = null) => {
        let value = _.get(window.SYSTEM_CONFIG, val);

        if (!value) {
            value = _.get(window.CONFIG, val, defaultValue);
        }

        return value;
    }

    static getLink = (url, type, appendQuery) => {
        if (!url || url.indexOf('//') !== -1) {
            return url;
        }
        const appendedQueryUrl = (url.indexOf('?') === -1 ? '?' : '&') + '_v=' + window.CONST.EVISIT.BUILD
        var query = (appendQuery === undefined || appendQuery) && window.CONST?.EVISIT?.BUILD ? appendedQueryUrl : '',
            absoluteUrl = (typeof window.webroot === 'string' ? window.webroot : '') + url + query;
        if (!type || ['html', 'js', 'css', 'img'].indexOf(type) === -1) return absoluteUrl;
        var domains = this.c('Assets.BaseUrl.' + type);
        if (!domains && type !== 'common') domains = this.c('Assets.BaseUrl.common');
        if (!domains) return absoluteUrl;

        if (typeof domains === 'string') return domains + absoluteUrl;
        if (typeof domains.indexOf === 'function') {
            if (domains.length === 0) return absoluteUrl;
            if (domains.length === 1) return domains[0] + absoluteUrl;
            var domainIndex = this.getUniqueNumberFromString(url) % domains.length;
            return domains[domainIndex] + absoluteUrl;
        } else {
            return absoluteUrl;
        }
    }

    static getImageUrl = (url) => {
        if (!url) return url;
        if (url.indexOf('//') !== -1) return url;
        if (!/^\/(health|img|js|css|vsee)\//.test(url)) url = '/img/' + url;
        url = url.replace(/\\/g, '/');
        return this.getLink(url, 'img');
    }

    static getUniqueNumberFromString = (s) => {
        if (!s) return 0;
        var total = 0;
        for (let i = 0, len = s.length; i < len; i++) {
            total += s.charCodeAt(i);
        }
        return total;
    }

    static #validateParentOrigin = (referrer) => {
        var whitelist = [
            /https:\/\/[^.]+\.vsee\.io\//,         // *.vsee.io
            /https:\/\/[^.]+\.vseepreview\.com\//, // *.vseepreview.com
            /https:\/\/[^.]+\.vsee\.me\//          // *.vsee.me
        ];
        for (var i in whitelist) {
            if (whitelist[i].test(referrer)) {
                return true;
            }
        }
        return false;
    }

    static #postMessageBackToParentApp = (data) => {
        var handler = null;
        if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined') {
            if (new RegExp("user.*").test(data["name"])) {
                handler = window.webkit.messageHandlers.userObject;
            } else if (new RegExp("visit.*").test(data["name"])) {
                handler = window.webkit.messageHandlers.visitDetailObject;
            } else if (new RegExp("workflow.*").test(data["name"])) {
                handler = window.webkit.messageHandlers.workflowObject;
            } else {
                return;
            }
        }

        if (handler) {
            handler.postMessage(data);
        } else if (typeof window.VseeAndroid !== 'undefined') {
            window.VseeAndroid.postMessage(JSON.stringify(data));
        }
    }

    static #postMessageBackToParentPage = (data) => {
        if (!this.#validateParentOrigin(document.referrer)) {
            return;
        }
        window.parent.postMessage(data, document.referrer);
    };

    static postMessageBackToParent = (data, handler) => {
        if (!data) {
            return;
        }

        // Post message back to the parent page
        this.#postMessageBackToParentPage(data);

        // Post message back to the parent mobile app
        this.#postMessageBackToParentApp(data);
    }

    static isIOSSafari = () => {
      const ua = navigator.userAgent;
      const regex = /iPad|iPhone|iPod/i; // Check if this is iOS device
      const safari = /Version\/[\d\.]+.*Safari/i; // Check if this is safari

      return regex.test(ua) && safari.test(ua);
    }

    /**
     * To tell if a value is existed in an array or object
     *
     * @param {*} obj object/array
     * @param {*} searchValue string/number
     * @returns true/false
     */
    static findValueInObj = (obj, searchValue) => Object.values(obj).some(val => {
        if (val === undefined || val === null) {
            return false;
        }
        const normalizedValue = typeof searchValue === "string" ? searchValue.toLowerCase() : searchValue;

        switch (typeof val) {
            case "number":
                return val === Number(normalizedValue);
            case "boolean":
                return String(val) === normalizedValue;
            case "object":
                return this.findValueInObj(val, normalizedValue);
            case "string":
                return val.toLowerCase().includes(normalizedValue);
            default:
                return false;
        }
    })

    static #getFormAction = (component, filter) => {
        // Currently we only support {event: submit}
        if (!_.get(filter, "event") || !component.logic) {
            return [];
        }
        var actions = [];
        _.filter(component.logic, ['trigger.event', filter["event"]]).forEach(function(logic) {
            actions = actions.concat(logic.actions);
        });
        return actions;
    }

    static executeActions = async (event, component, submission, data) => {
        var actions = this.#getFormAction(component, {event: event});
        submission = submission.data;
        var value = submission;
        for (var i in actions) {
            var action = actions[i];
            if (action.type !== "customAction") {
                return true;
            }
            await eval(action.customAction);
        }
        return value;
    }

    static getDisplayVisitId = (visit) => {
        if (Evisit.c('Account.visit_options.reference_key.enabled') && Evisit.c('Account.visit_options.reference_key.id')) {
            const key = Evisit.c('Account.visit_options.reference_key.id');
            return _.get(visit, `${key}`, visit.id);
        }

        return _.get(visit, 'id', "");
    }

    static validatePhoneNumber(phone) {
        return /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(phone);
    }
}

export default Evisit;
